"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectStyle = exports.FilterContainer = void 0;
const tslib_1 = require("tslib");
const styled_components_1 = (0, tslib_1.__importDefault)(require("styled-components"));
exports.FilterContainer = styled_components_1.default.div `
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 0.7fr 0.8fr 1fr;
  column-gap: 10px;
  justify-items: stretch;
  align-items: center;
  justify-content: center;
  align-content: center;
`;
exports.SelectStyle = {
    control: (base) => (Object.assign(Object.assign({}, base), { height: 54 })),
};
